import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LabelPrintProvider } from "@/context/LabelPrintContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Painel from "@/pages/Painel";
import Entrada from "@/pages/Entrada";
import Romaneio from "@/pages/Romaneio";
import Romaneios from "@/pages/Romaneios";
import BackupAdmin from "@/pages/BackupAdmin";
import Devolucao from "@/pages/Devolucao";
import Rolos from "@/pages/Rolos";
import Cadastro from "@/pages/Cadastro";
import Historico from "@/pages/Historico";
import Configuracoes from "@/pages/Configuracoes";
import TrocarSenha from "@/pages/TrocarSenha";
import Usuarios from "@/pages/Usuarios";
import SemAcesso from "@/pages/SemAcesso";
import Calculadora from "@/pages/Calculadora";
import EstoqueGolaPunho from "@/pages/EstoqueGolaPunho";
import { RequireRoute } from "@/components/RequireRoute";
import { ThemeProvider } from "@/context/ThemeContext";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center text-slate-500" data-testid="loading">
        Carregando...
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <LabelPrintProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                  element={
                    <Protected>
                      <Layout />
                    </Protected>
                  }
                >
                  <Route path="/" element={<RequireRoute perm="painel:view"><Painel /></RequireRoute>} />
                  <Route path="/entrada" element={<RequireRoute perms={["entrada:individual","entrada:lote","entrada:ver_docs"]}><Entrada /></RequireRoute>} />
                  <Route path="/entradas" element={<Navigate to="/entrada" replace />} />
                  <Route path="/romaneio" element={<RequireRoute perm="romaneio:view"><Romaneios /></RequireRoute>} />
                  <Route path="/romaneio/novo" element={<RequireRoute perm="romaneio:criar"><Romaneio /></RequireRoute>} />
                  <Route path="/admin/backup" element={<RequireRoute masterOnly><BackupAdmin /></RequireRoute>} />
                  <Route path="/devolucao" element={<RequireRoute perm="devolucao:executar"><Devolucao /></RequireRoute>} />
                  <Route path="/rolos" element={<RequireRoute perm="estoque:view"><Rolos /></RequireRoute>} />
                  <Route path="/cadastro" element={<RequireRoute perms={["cadastro:fornecedores_view","cadastro:combinacoes_view"]}><Cadastro /></RequireRoute>} />
                  <Route path="/historico" element={<RequireRoute masterOnly><Historico /></RequireRoute>} />
                  <Route path="/configuracoes" element={<Configuracoes />} />
                  <Route path="/trocar-senha" element={<TrocarSenha />} />
                  <Route path="/usuarios" element={<RequireRoute masterOnly><Usuarios /></RequireRoute>} />
                  <Route path="/calculadora" element={<RequireRoute perm="calculadora:view"><Calculadora /></RequireRoute>} />
                  <Route path="/gola-punho" element={<RequireRoute perm="estoque_gp:view"><EstoqueGolaPunho /></RequireRoute>} />
                  <Route path="/sem-acesso" element={<SemAcesso />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </LabelPrintProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
